// Decodificación base64url (RFC 4648 §5: alfabeto con - y _, sin padding).
// Fuente única: la usan el decode de claves VAPID (pushClient) y la lectura
// del payload de JWT (jwt.js) — antes cada uno traía su copia de la
// normalización y podían divergir en padding/alfabeto.

/**
 * Convierte un string base64url a Uint8Array.
 *
 * @param {string} base64String
 * @returns {Uint8Array}
 */
export function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = globalThis.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
